module.exports = __webpack_public_path__ + "static/media/fire.3824e99c.wav";